// aiStartTour.js — the assistant's `start_tour` (server workspaceTools.js):
// THE QUICK TOUR on demand (functions/onboardingTour.js — a few highlighted
// stops over the member's real screen). Nika 2026-10-18, "close all
// followups": a member who asked the assistant for a tour got prose about it.
//
// The tour points at the HOME page's chrome (the navbar, the App strip, the
// composer), so it starts there: a page sheet open in the PageSlot steps aside
// (the same writes as open_page_in_split's close), and off the home the shell
// goes home first — the open the phone dock's Home makes (`openAppPage('/')`).
// The main thread stays: on the home it never hides the App strip or the
// composer, and a navigation already clears it. Then the welcome's own beat
// (320 ms) and `onboardingTourStart`.
//
// A CLIENT TOOL (simoneAiTransport CLIENT_TOOL_FNS; read-only class — it
// changes only what the member sees, so Ask-first never asks). Answers
// `{ ok: true, started: true, stops, note }` for the model to read, or
// `{ ok: false, error }`. It writes no onboarding decision. The `note` says
// what the screen now shows and how little to say: the tool's description
// asks for one short sentence, and live on dev (ba591daf1) the model still
// wrote three about the stops — the result is what it reads last.
//
// `opts` — test seams: { beatMs, homeWaitMs, stepMs }.
//
// FRANK: one self-contained export (FA204); siblings through `this.call`.
export async function aiStartTour(opts) {
  const el = this
  const root = el && el.state && el.state.root
  if (!root || typeof root.update !== 'function' || !el || typeof el.call !== 'function') {
    return { ok: false, error: 'No workspace screen is available for the tour.' }
  }
  const fns = (el.context && el.context.functions) || {}
  if (typeof fns.onboardingTourStart !== 'function') {
    return { ok: false, error: 'This workspace has no tour.' }
  }
  const o = opts && typeof opts === 'object' ? opts : {}
  const beatMs = typeof o.beatMs === 'number' ? o.beatMs : 320
  const homeWaitMs = typeof o.homeWaitMs === 'number' ? o.homeWaitMs : 3000
  const stepMs = typeof o.stepMs === 'number' ? o.stepMs : 100
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
  const onHome = () => {
    const raw = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/'
    const stripped = el.call('stripWorkspacePrefix', raw)
    const path = String(typeof stripped === 'string' ? stripped : raw).split(/[?#]/)[0]
    return path === '/' || path === ''
  }

  // A page sheet over the home covers the stops.
  if (root._canvasSlot || root._canvasSlotSecond) {
    root.update({ _canvasSlot: null, _canvasSlotSecond: null, _slotFullscreen: null })
  }
  if (!onHome()) {
    try {
      await el.call('openAppPage', '/')
    } catch (_) {
      // the wait below decides
    }
    const until = Date.now() + homeWaitMs
    while (!onHome() && Date.now() < until) await wait(stepMs)
    if (!onHome()) {
      return { ok: false, error: 'The home page did not open, so the tour could not start.' }
    }
  }
  await wait(beatMs)
  el.call('onboardingTourStart')
  const tour = root._onboardingTour
  if (!tour) return { ok: false, error: 'The tour could not start.' }
  return {
    ok: true,
    started: true,
    stops: Number(tour.total) || 0,
    // Live on dev 3103cfd the first note stopped the description of the stops
    // but not the filler ("Of course. I've started the workspace tour for you.
    // Follow the steps on your screen…"): a word ceiling and the parts to
    // leave out are what a model keeps to.
    note:
      "The tour is on the member's screen now; each stop explains itself there. " +
      "Answer with ONE short sentence of at most eight words, in the member's " +
      'language — no greeting, no list, and do not describe the stops.'
  }
}
